import _ from 'lodash'

function mapObject(obj, fn) {
  return _.toPairs(obj).reduce((acc, pair) => {
    const [key, value] = pair
    return { ...acc, [key]: fn(value, key) }
  }, {})
}

function populateId(obj) {
  return mapObject(obj, (value, id) => ({ ...value, id }))
}

function populateIdAsArrayIndex(arr) {
  return arr.map((v, id) => ({ ...v, id }))
}

// content must be acyclic graph
export default function populate(content) {
  const tracks = populateId(content.data.tracks)
  const presenters = populateId(content.data.presenters)
  const presentations = populateId(
    mapObject(content.data.presentations, presentation => {
      return {
        ...presentation,
        presenter: presenters[presentation.presenter],
      }
    })
  )
  const sessions = populateIdAsArrayIndex(
    content.data.sessions.map(session => {
      const result = { ...session }
      if (session.presentation) {
        result.presentation = presentations[session.presentation]
      }
      if (session.track) {
        result.track = tracks[session.track]
      }
      return result
    })
  )
  return {
    ...content,
    data: {
      ...content.data,
      presenters,
      presentations,
      sessions,
      tracks,
    },
  }
}



// WEBPACK FOOTER //
// ./src/content/populate.js